/* eslint-disable global-require */
import React from 'react';
// import PropTypes from 'prop-types';

import Article from '../Article';

const classNames = require('classnames');

const Solution = () => {
  const className = classNames({
    solution: true
  });

  return (
    <div className={className}>
      <div className="solutio " style={{ width: '100%' }}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <Article center>
                <header className="article__header">
                  <h2>Proctortracks approved solution for Linguaskill</h2>
                </header>
                <section className="article__section">
                  <p>
                    Proctortrack delivers a transparent proctoring solution, and a more comfortable
                    experience for students and instructors.
                  </p>
                </section>
              </Article>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="box">
                <img alt="/" src={require('./1.png')} />
                <h3>Student Test</h3>
                <br />
                <p>
                  Students launch the Protortrack application from inside their LMS to take a
                  proctored test.
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="box">
                <img alt="/" src={require('./2.png')} />
                <h3>Algorithmic Analysis</h3>
                <br />
                <p>
                  Proctortrack filters proctoring results to focus instructors’ time on the students
                  and incidents that require their attention.
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="box">
                <img alt="/" src={require('./3.png')} />
                <h3>Efficiently Review Results</h3>
                <br />
                <p>
                  Student proctoring reports include pre-flagged evidence of any misconduct to
                  ensure results are delivered in context.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
Solution.defaultProps = {};
Solution.propTypes = {};
export default Solution;
